module.exports = __webpack_public_path__ + "img/svg - right boy.b1a6ca47.svg";